import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Officecabservicepune() {



const cardData = {
  keyword: " Office Cab Service Pune ",

"headingDescription": "SRS Cab Service offers Office Cab Service in Pune, providing safe, punctual, and comfortable travel solutions for corporate employees. Whether it’s daily office commutes, shuttle services, or team transfers, our well-maintained vehicles and professional drivers ensure a smooth and hassle-free journey. With flexible routes, transparent pricing, and 24/7 customer support, SRS Cab Service makes office commuting in Pune efficient, reliable, and stress-free.",
"topPlaces": [
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "A major IT hub in Pune where many corporate offices are located. SRS Cab Service provides timely office cab services for employees traveling to this location."
  },
  {
    "title": "Hinjewadi Phase 1 & 2",
    "description": "Home to numerous IT companies, Hinjewadi relies on SRS Cab Service for smooth office commute solutions for employees."
  },
  {
    "title": "Magarpatta City",
    "description": "A prominent corporate campus where office employees frequently travel. SRS Cab Service ensures reliable commuting to and from Magarpatta City."
  },
  {
    "title": "EON IT Park",
    "description": "SRS Cab Service provides professional office cab services for employees working at EON IT Park, ensuring punctuality and convenience."
  },
  {
    "title": "Kalyani Nagar",
    "description": "A residential and corporate hub. Office cab services from SRS Cab Service help employees commute efficiently from this locality."
  },
  {
    "title": "Viman Nagar",
    "description": "SRS Cab Service facilitates comfortable and timely office travel for employees residing in or commuting to Viman Nagar."
  },
  {
    "title": "Baner",
    "description": "A commercial and IT zone. Employees use SRS Cab Service for hassle-free office transportation to Baner offices."
  },
  {
    "title": "Pimpri Chinchwad Industrial Area",
    "description": "Industrial and corporate workplaces rely on SRS Cab Service for safe and reliable office cab services for their teams."
  },
  {
    "title": "Hadapsar",
    "description": "A fast-growing corporate and industrial hub. Employees benefit from SRS Cab Service for punctual and comfortable office travel."
  },
  {
    "title": "Wakad",
    "description": "A residential and IT hub in Pune. SRS Cab Service ensures smooth commuting for office-going professionals residing in Wakad."
  }
],



services: [
{
name: "Daily Office Cab Service Pune",
description: "Daily office cab service Pune offers reliable transportation for employees and office staff. Companies can book regular pickup and drop services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with office cab services."
},
{
name: "Office Cab Service Pune",
description: "Office cab service Pune provides convenient travel solutions for corporate employees. Businesses can arrange daily commute services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with office cab services."
},
{
name: "Office Cab Service in Pune",
description: "Office cab service in Pune offers dependable transportation for daily office travel. Companies can book cabs for staff commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with cab services."
},
{
name: "Pune Office Cab Service",
description: "Pune office cab service provides reliable transport for office employees and teams. Businesses can arrange daily travel solutions. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with office cab services."
},
{
name: "Office Taxi Service Pune",
description: "Office taxi service Pune offers efficient transportation for staff and corporate travel. Companies can book taxis for daily commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with taxi services."
},
{
name: "Office Cab Booking Pune",
description: "Office cab booking Pune provides easy reservation options for businesses and employees. Companies can book cabs anytime for staff travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Office Taxi Booking Pune",
description: "Office taxi booking Pune offers convenient booking services for corporate travel. Companies can reserve taxis for daily commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Corporate Office Cab Service Pune",
description: "Corporate office cab service Pune provides organized transport for company employees. Businesses can manage daily pickup and drop efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible routes are available. Travel easily with corporate cab services."
},
{
name: "Office Transport Service Pune",
description: "Office transport service Pune offers reliable travel solutions for employees. Companies can arrange daily commute services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with transport services."
},
{
name: "Office Pickup and Drop Cab Pune",
description: "Office pickup and drop cab Pune offers smooth daily commute for employees. Companies can schedule fixed routes and timings. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with pickup and drop services."
},
{
name: "Office Commute Cab Service Pune",
description: "Office commute cab service Pune provides reliable daily travel for staff and teams. Companies can ensure timely office commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with commute services."
},
{
name: "Office Staff Cab Service Pune",
description: "Office staff cab service Pune offers dependable travel solutions for company employees. Businesses can arrange daily transport services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with staff cab services."
},
{
name: "Office Travel Cab Pune",
description: "Office travel cab Pune provides convenient transport for employees and business trips. Companies can book cabs for daily and occasional travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel cab services."
},
{
name: "Office Cab Hire Pune",
description: "Office cab hire Pune offers flexible rental options for corporate travel. Companies can book cabs for daily or monthly use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Office Taxi Hire Pune",
description: "Office taxi hire Pune provides convenient rental services for corporate employees. Businesses can book taxis for daily commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Company Office Cab Service Pune",
description: "Company office cab service Pune offers reliable transport for employees and teams. Businesses can arrange daily pickup and drop services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with company cab services."
},
{
name: "Office Cab Provider Pune",
description: "Office cab provider Pune offers complete transport solutions for companies. Businesses can outsource employee commute services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible service plans are available. Travel easily with cab providers."
},
{
name: "Office Cab Service Near Me Pune",
description: "Office cab service near me Pune helps businesses find nearby transport services quickly. Companies can book cabs instantly for employees. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Office Cab Service Pune Contact",
description: "Office cab service Pune contact helps customers connect easily for booking services. Companies can inquire about transport solutions quickly. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Office Cab Service Pune for Companies",
description: "Office cab service Pune for companies provides customized transport for corporate clients. Businesses can manage employee travel efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible plans are available. Travel easily with corporate cab services."
},
{
name: "Office Transport Cab Pune",
description: "Office transport cab Pune offers reliable travel solutions for employees and teams. Companies can arrange daily commute services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with transport services."
},
{
name: "Innova Office Cab Pune",
description: "Innova office cab Pune offers spacious SUV travel for corporate employees. Companies can book vehicles for team transport. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for group commute. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Office Cab Pune",
description: "Innova Crysta office cab Pune provides premium SUV travel for employees. Companies can ensure comfortable daily commute. Professional drivers ensure safe journeys. Spacious seating enhances experience. Ideal for corporate travel. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Office Cab Pune",
description: "Ertiga office cab Pune offers comfortable 7 seater travel for staff transport. Companies can book vehicles for team commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Office Cab Pune",
description: "Dzire office cab Pune provides affordable sedan travel for employee commute. Companies can book vehicles for daily travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Office Cab Pune",
description: "Sedan office cab Pune offers budget-friendly travel for office staff. Companies can book vehicles for daily commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan transport services."
},
{
name: "Tempo Traveller Office Transport Pune",
description: "Tempo traveller office transport Pune offers group travel for company employees. Businesses can book vehicles for large teams. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania Office Bus Transport Pune",
description: "Urbania office bus transport Pune provides premium group travel for corporate teams. Companies can book luxury vehicles for staff commute. Professional drivers ensure safe journeys. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Mini Bus Office Transport Pune",
description: "Mini bus office transport Pune offers efficient group travel for employees. Companies can arrange transport for medium teams. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with mini bus services."
}
],

tableData: [
["Daily Office Cab Service Pune","Office Cab Service Pune"],
["Office Cab Service in Pune","Pune Office Cab Service"],
["Office Taxi Service Pune","Office Cab Booking Pune"],
["Office Taxi Booking Pune","Corporate Office Cab Service Pune"],
["Office Transport Service Pune","Office Pickup and Drop Cab Pune"],
["Office Commute Cab Service Pune","Office Staff Cab Service Pune"],
["Office Travel Cab Pune","Office Cab Hire Pune"],
["Office Taxi Hire Pune","Company Office Cab Service Pune"],
["Office Cab Provider Pune","Office Cab Service Near Me Pune"],
["Office Cab Service Pune Contact","Office Cab Service Pune for Companies"],
["Office Transport Cab Pune","Innova Office Cab Pune"],
["Innova Crysta Office Cab Pune","Ertiga Office Cab Pune"],
["Dzire Office Cab Pune","Sedan Office Cab Pune"],
["Tempo Traveller Office Transport Pune","Urbania Office Bus Transport Pune"],
["Mini Bus Office Transport Pune","Office Cab Service Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Office Cab Service in Pune",
    WhyChoosedescription: "SRS Cab Service provides dependable office cab service in Pune for daily employee commute, IT staff transport, corporate travel, and business meetings with professional drivers and smooth coordination."
  },
  {
    WhyChooseheading: "Customized Office Transport Solutions",
    WhyChoosedescription: "We offer flexible office cab services with shift-based pickup, route optimization, and dedicated vehicles tailored to your company’s daily transportation needs."
  },
  {
    WhyChooseheading: "24/7 Office Cab Availability",
    WhyChoosedescription: "Our office cab service in Pune operates 24/7 to support early morning shifts, night shifts, and flexible work schedules for IT companies and corporate offices."
  },
  {
    WhyChooseheading: "Wide Range of Fleet Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and AC buses for small teams to large employee groups."
  },
  {
    WhyChooseheading: "GPS Tracking & Safety Features",
    WhyChoosedescription: "All vehicles are equipped with GPS tracking for real-time monitoring, ensuring employee safety, route efficiency, and complete transparency for office travel."
  },
  {
    WhyChooseheading: "Verified Drivers & Professional Service",
    WhyChoosedescription: "Our drivers are background-verified, trained, and experienced to provide safe, punctual, and professional service for office cab requirements."
  },
  {
    WhyChooseheading: "On-Time Pickup & Drop Service",
    WhyChoosedescription: "We ensure timely pickup and drop for employees, helping companies maintain punctuality and improve workforce productivity."
  },
  {
    WhyChooseheading: "Trusted Office Cab Service Provider in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by corporates and IT companies in Pune for reliable office cab services, affordable pricing, and consistent service quality."
  }
]
}

const faqData = [
  { 
    question: "Do you provide office cab service in Pune?", 
    answer: "Yes, SRS Cab Service offers reliable office cab service in Pune for daily employee commute, corporate travel, and IT staff transportation with safe and professional service." 
  },
  { 
    question: "Can office cab services be customized?", 
    answer: "Yes, we provide customized office transport solutions including shift-wise pickup, route planning, and dedicated vehicles based on company requirements." 
  },
  { 
    question: "Is office cab service available 24/7?", 
    answer: "Yes, our office cab service operates 24/7 to support night shifts, early morning shifts, and flexible office timings." 
  },
  { 
    question: "Which vehicles are available for office transport?", 
    answer: "We offer sedan cars, SUVs, Innova Crysta, Tempo Travellers, and buses depending on the number of employees and travel requirements." 
  },
  { 
    question: "Do you provide GPS tracking in office cabs?", 
    answer: "Yes, all our office cabs are equipped with GPS tracking for real-time monitoring and enhanced employee safety." 
  },
  { 
    question: "Are drivers verified and trained?", 
    answer: "Yes, all drivers are background-verified, trained, and experienced to ensure safe and professional service." 
  },
  { 
    question: "Do you provide office cab service in Hinjewadi and Baner?", 
    answer: "Yes, we provide office cab service across major corporate areas like Hinjewadi, Baner, Wakad, Kharadi, and Viman Nagar." 
  },
  { 
    question: "Is service available for small and large teams?", 
    answer: "Yes, we provide flexible transport solutions for both small teams and large employee groups." 
  },
  { 
    question: "Are office cab services affordable?", 
    answer: "Yes, we offer cost-effective office cab services with transparent pricing and customized plans for businesses." 
  },
  { 
    question: "How can I book office cab service in Pune?", 
    answer: "You can book office cab service by contacting us directly. We provide quick onboarding and easy service setup for companies." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "HR Executive - IT Company",
    feedback:
      "We have been using SRS Cab Service for office commute in Pune and the experience has been excellent. Drivers are punctual, vehicles are clean, and service is very reliable.",
    rating: 5
  },
  {
    id: 2,
    name: "Admin Manager - Corporate Office",
    feedback:
      "Best office cab service in Pune. Their coordination, safety measures, and on-time service make daily employee transport very smooth and efficient.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Office Cab Service Pune",
  "description": "Reliable office cab service in Pune with SRS Cab. Daily office pickup and drop, corporate office cab bookings, and staff commute services available 24/7 with Innova, Ertiga, sedan, SUV, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/office-cab-service-pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune, Maharashtra"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Office Cab Service in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable office cab service in Pune with SRS Cab. Daily office pickup/drop, corporate bookings, and staff commute services available 24/7. Innova, Ertiga, sedan, SUV, and tempo traveller options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Officecabservicepune;